import { Components, Theme } from '@mui/material';

export const inputLabelStyles: Components<Theme>['MuiInputLabel'] = {
  styleOverrides: {
    root: ({ theme }) => ({
      color: theme.palette.text.primary,
      fontStyle: 'normal',
      fontSize: '18px',
      lineHeight: '24px',
      fontWeight: 600,
      marginBottom: 8
    })
  }
};
